import { useState } from "react";

export default function ServicesTable({
  sectionId,
  services,
  onDelete,
  onAdd,
  onEdit,
}) {
  const [editingItem, setEditingItem] = useState(null);
  const [form, setForm] = useState({
    title: "",
    description: "",
    status: "Active",
  });

  const openAdd = () => {
    setEditingItem(null);
    setForm({ title: "", description: "", status: "Active" });
  };

  const openEdit = (item) => {
    setEditingItem(item);
    setForm({
      title: item.title,
      description: item.description,
      status: item.status || "Active",
    });
  };

  const handleSubmit = () => {
    if (editingItem) {
      onEdit(editingItem.id, form);
    } else {
      onAdd(form);
    }
    setEditingItem(null);
    setForm({ title: "", description: "", status: "Active" });
  };

  return (
    <section
      id={sectionId}
      className="rounded-[30px] border border-white/10 bg-[#101014] p-6"
    >
      {/* HEADER */}
      <div className="mb-6 flex justify-between">
        <h2 className="text-white text-2xl font-bold">Services</h2>

        <button
          onClick={openAdd}
          className="bg-[#F28C18] px-4 py-2 rounded-xl text-black font-bold"
        >
          + Add Service
        </button>
      </div>

      {/* FORM */}
      <div className="mb-6 space-y-3 bg-black/20 p-4 rounded-xl">
        <input
          className="w-full p-2 rounded bg-black text-white"
          placeholder="Title"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
        />

        <input
          className="w-full p-2 rounded bg-black text-white"
          placeholder="Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />

        <select
          className="w-full p-2 rounded bg-black text-white"
          value={form.status}
          onChange={(e) => setForm({ ...form, status: e.target.value })}
        >
          <option>Active</option>
          <option>Inactive</option>
        </select>

        <button
          onClick={handleSubmit}
          className="bg-green-500 px-4 py-2 rounded font-bold"
        >
          {editingItem ? "Update" : "Create"}
        </button>
      </div>

      {/* LIST */}
      <div className="space-y-3">
        {services?.map((item) => (
          <div
            key={item.id}
            className="flex justify-between items-center bg-black/30 p-4 rounded-xl"
          >
            <div>
              <h3 className="text-white font-bold">{item.title}</h3>
              <p className="text-gray-400 text-sm">{item.description}</p>
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => openEdit(item)}
                className="bg-blue-500 px-3 py-1 rounded"
              >
                Edit
              </button>

              <button
                onClick={() => onDelete(item.id)}
                className="bg-red-500 px-3 py-1 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}